import { useState } from "react";
import {
  Box,
  Typography,
  useTheme,
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  Button,
  MenuItem,
  FormControlLabel,
  Switch,
} from "@mui/material";
import Header from "../../components/Header";
const TokenGatingInfo = ({
  onHandleDiscourseNftTokenGatingDataInputChange,
  discourseNftTokenGatingData,
  discourseDetails,
  onHandleDiscourseDetailsInputChange,
  handleRemoveClick,
  handleAddClick,
}) => {
  const [toggleState, setToggleState] = useState(false);
  const handleToggleChange = () => {
    setToggleState(!toggleState);
  };
  return (
    <Box m="40px" ml="70px">
      <Header
        title="Token Gating Configuration"
        subtitle="Provide Token Gating configuration"
      />

      <Grid container spacing={2}>
        <Grid item md={12} xs={12} sm={12}>
          <FormControlLabel
            control={
              <Switch
                checked={toggleState}
                onChange={handleToggleChange}
                name="toggleSwitch"
                color="primary"
                sx={{
                  "& .MuiSwitch-thumb": {
                    backgroundColor: toggleState ? "#2196F3" : "#000",
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: toggleState ? "#BBDEFB" : "#000",
                  },
                }}
              />
            }
            label={
              !toggleState
                ? "Enable Token Gating Configuration"
                : "Disable Token Gating Configuration"
            }
          />
        </Grid>
        {toggleState && (
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <TextField
                name="adminForumUserName"
                label="Enter the username of the admin account "
                variant="outlined"
                type="text"
                fullWidth
                sx={{ mt: 1, boxShadow: 2, mb: 1 }}
                value={discourseDetails.adminForumUserName}
                onChange={onHandleDiscourseDetailsInputChange}
                required
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <TextField
                name="discourseAPI"
                label="Enter the discourse forum API "
                variant="outlined"
                type="text"
                fullWidth
                sx={{ mt: 1, boxShadow: 2, mb: 1 }}
                value={discourseDetails.discourseAPI}
                onChange={onHandleDiscourseDetailsInputChange}
                required
              />
            </Grid>
          </Grid>
        )}

        {toggleState &&
          discourseNftTokenGatingData.map((currentElement, index) => {
            return (
              <Grid container key={index} direction="row">
                <Grid item md={3} sm={3} xs={3}>
                  <TextField
                    sx={{ ml: 6, mt: 2, boxShadow: 2 }}
                    fullWidth
                    required
                    name="categoryId"
                    variant="outlined"
                    label="Enter the category Id"
                    type="text"
                    id="categoryId"
                    value={currentElement.categoryId}
                    onChange={(event) =>
                      onHandleDiscourseNftTokenGatingDataInputChange(
                        event,
                        index
                      )
                    }
                  />
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <FormControl
                    sx={{ ml: 6.5, mt: 2, boxShadow: 2 }}
                    fullWidth
                    required
                  >
                    <InputLabel id="demo-simple-select-label">
                      Select BlockChain
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="blockChain"
                      label="Select BlockChain"
                      value={currentElement.blockChain}
                      onChange={(event) =>
                        onHandleDiscourseNftTokenGatingDataInputChange(
                          event,
                          index
                        )
                      }
                    >
                      <MenuItem value={"Ethereum"}>Ethereum</MenuItem>
                      <MenuItem value={"Polygon"}>Polygon</MenuItem>
                      <MenuItem value={"POAP/xDai"}>POAP/xDAI</MenuItem>
                      <MenuItem value={"Sepolia-Ethereum"}>
                        Sepolia Ethereum
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <FormControl
                    sx={{ ml: 7, mt: 2, boxShadow: 2 }}
                    fullWidth
                    required
                  >
                    <InputLabel id="demo-simple-select-label">
                      Token Standard
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="tokenStandard"
                      label="Enter Smart Contract Token Standard"
                      value={
                        currentElement.blockChain == "POAP/xDai"
                          ? (currentElement.tokenStandard = "ERC721")
                          : currentElement.tokenStandard
                      }
                      onChange={(event) =>
                        onHandleDiscourseNftTokenGatingDataInputChange(
                          event,
                          index
                        )
                      }
                      disabled={
                        currentElement.blockChain == "POAP/xDai" ? true : false
                      }
                    >
                      <MenuItem value={"ERC721"}>ERC721</MenuItem>
                      <MenuItem value={"ERC1155"}>ERC1155</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={1} xs={1} sm={1}>
                  {
                    <Button
                      disabled={
                        discourseNftTokenGatingData.length - 1 === index
                          ? false
                          : true
                      }
                      variant="contained"
                      sx={{ mt: 6, ml: 8 }}
                      onClick={handleAddClick}
                      className="custom-color-button"
                    >
                      Add
                    </Button>
                  }
                </Grid>
                <Grid item md={1} xs={1} sm={1}>
                  {
                    <Button
                      disabled={
                        discourseNftTokenGatingData.length == 1 ? true : false
                      }
                      variant="contained"
                      sx={{ mt: 6, ml: 8 }}
                      onClick={() => handleRemoveClick(index)}
                      color="error"
                    >
                      Remove
                    </Button>
                  }
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <TextField
                    sx={{ ml: 6, boxShadow: 2 }}
                    fullWidth
                    required
                    name="contractAddress"
                    label={
                      currentElement.blockChain == "POAP/xDai"
                        ? "Event ID"
                        : "Contract Address"
                    }
                    variant="outlined"
                    type="text"
                    id="contractAddress"
                    value={currentElement.contractAddress}
                    onChange={(event) =>
                      onHandleDiscourseNftTokenGatingDataInputChange(
                        event,
                        index
                      )
                    }
                  />
                </Grid>

                <Grid item md={3} sm={3} xs={3}>
                  <TextField
                    sx={{ ml: 6.5, boxShadow: 2 }}
                    fullWidth
                    name="tokenId"
                    variant="outlined"
                    value={currentElement.tokenId}
                    label="Token Id"
                    type="text"
                    id="tokenId"
                    onChange={(event) =>
                      onHandleDiscourseNftTokenGatingDataInputChange(
                        event,
                        index
                      )
                    }
                  />
                </Grid>
                <Grid item md={3} sm={3} xs={3}>
                  <TextField
                    sx={{ ml: 6.9, boxShadow: 2 }}
                    fullWidth
                    required
                    name="nftsRequired"
                    variant="outlined"
                    label="Nfts Required"
                    inputProps={{ type: "number", min: 1 }}
                    id="nftsRequired"
                    value={currentElement.nftsRequired}
                    onChange={(event) => {
                      const value = event.target.value;
                      if (value === "" || value > 0) {
                        onHandleDiscourseNftTokenGatingDataInputChange(
                          event,
                          index
                        );
                      }
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
};

export default TokenGatingInfo;
